
interface DIRECTIONTYPES {
  up: string,
  right: string,
  left: string,
  down: string,
}

export const Direction: DIRECTIONTYPES = {
  up: 'up',
  right: 'right',
  left: 'left',
  down: 'down',
}

export const OppositeDirection: any = {
    up: 'down',
    right: 'left',
    left: 'right',
    down: 'up',
}
        
export const Delta: any = {
    up: { x: 0, y: -1 },
    right: { x: 1, y: 0 },
    left: { x: -1, y: 0 },
    down: { x: 0, y: 1 },
}

export const DirectionKeyCodeMap: any = {
    ArrowLeft: Direction.left,
    ArrowUp: Direction.up,
    ArrowRight: Direction.right,
    ArrowDown: Direction.down,
};